import { CheckCircle2, ServerCrash, Wifi, WifiOff, type LucideIcon } from 'lucide-react';
import type { StatusColorTone } from '@/styles/statusColors';

export type ProblemMode = 'offline' | 'unreachable';
export type BannerMode = ProblemMode | 'reconnected-network' | 'reconnected-server';

export const RECONNECTED_DISPLAY_MS = 3000;

export const RECOVERY_BANNER_FOR: Record<ProblemMode, BannerMode> = {
  offline: 'reconnected-network',
  unreachable: 'reconnected-server',
};

export const MODE_STYLES: Record<
  BannerMode,
  { icon: LucideIcon; tone: StatusColorTone; message: string }
> = {
  offline: {
    icon: WifiOff,
    tone: 'warning',
    message: 'You are offline',
  },
  unreachable: {
    icon: ServerCrash,
    tone: 'danger',
    message: 'Cannot reach the server',
  },
  'reconnected-network': {
    icon: Wifi,
    tone: 'success',
    message: 'Back online',
  },
  'reconnected-server': {
    icon: CheckCircle2,
    tone: 'success',
    message: 'Server is back',
  },
};
